// src/api/crm.js
import axios from "axios";
import { BASE_API } from "../utils/constants";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || `${BASE_API}`,
});
// ====== LEADS LIST / DELETE ======
export const getLeads = async (token, params = {}) => {
  const { data } = await api.get("/api/crm/leads/", {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
  return data;
};

export const deleteLead = async (id, token) => {
  await api.delete(`/api/crm/leads/${id}/`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return true;
};

// ====== KANBAN ======
export const getKanban = async (token, params = {}) => {
  const { data } = await api.get("/api/crm/kanban/", {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
  return data;
};


export const moveLead = (id, payload, token) =>
  api.patch(`/api/crm/leads/${id}/move/`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });

// ====== LEADS ======
export const createLead = async (payload, token) => {
  const { data } = await api.post("/api/crm/leads/", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const updateLead = async (id, payload, token) => {
  const { data } = await api.patch(`/api/crm/leads/${id}/`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const getLead = async (id, token) => {
  const { data } = await api.get(`/api/crm/leads/${id}/`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

// ====== AUX: STAGES / SOURCES ======
export const getStages = async (token) => {
  const { data } = await api.get(`/api/crm/stages/`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const getSources = async (token) => {
  const { data } = await api.get(`/api/crm/sources/`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};
